import { Auth } from "aws-amplify";

export const generateBaseAwsConfig = (
  lambdaBaseUrl: string,
  graphqlBaseUrl: string,
) => {
  return {
    API: {
      graphql_endpoint: `${graphqlBaseUrl}/v1/graphql`,
      graphql_headers: async () => ({
        Authorization:
          "Bearer " + (await Auth.currentSession()).getIdToken().getJwtToken(),
      }),
      endpoints: [
        {
          name: "public",
          endpoint: `${lambdaBaseUrl}/public`,
        },
        {
          name: "auth",
          endpoint: `${lambdaBaseUrl}/auth`,
          custom_header: async () => ({
            Authorization: (await Auth.currentSession())
              .getIdToken()
              .getJwtToken(),
          }),
        },
      ],
    },
    Analytics: {
      disabled: true,
    },
  };
};
